<template>
  <div class="mb-5 pt-0 mt-0">
    <div v-if = "CONSTANTS.MESSAGE_FOR_SUPPLIER_CENTRAL_DOWN.length>0" class="alert-container mb-2" >
              <div class="fade-in-out alert alert-error" >
                <div><strong>{{CONSTANTS.MESSAGE_FOR_SUPPLIER_CENTRAL_DOWN}}</strong></div>
              </div>
            </div>
    <div class="main-title mb-2 align-with-table">Recently submitted invoices</div>
    <div class="row d-block px-4 py-2">
      <div class="font-italic" v-html="FORM_LABELS.ACCOUNTS_PAYABLE_HELP_TEXT"/>
    </div>
    <div class="row no-gutters">
      <vue-good-table
          :columns="submittedInvoicesColumns"
          :rows="submittedInvoicesRows"
          class="table-word-wrap"
          :sort-options="{
            enabled: true,
            initialSortBy: {field: 'formattedCreatedOn', type: 'desc'}
          }"
          :pagination-options="{enabled: this.invoiceSubmissionStatusPaginationEnabled, ...paginationOptions}"
          v-if="invoiceSubmissionStatusRecords && invoiceSubmissionStatusRecords.length > 0"
      >
        <div slot="emptystate">{{ noRecordsMessage }}</div>
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'attachedFileName'">
            <span :key="index" v-for="(attachments,index) in props.row.attachedFileName">
              {{attachments}}<br>
            </span>
          </span>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
import {VueGoodTable} from "vue-good-table";
import {mapGetters} from "vuex";
import CONSTANTS from "@/store/constants";
import FORM_LABELS from "@/store/FormLabels";
import moment from "moment";
import "moment-timezone"
import PaymentFormsMixin from "../../mixins/PaymentFormsMixin";
import VGT_COLUMNS from "../../store/vgtColumns";
import VGT_PAGINATION_OPTIONS from "../../store/vgtPaginationOptions";

export default {
  name: "UserInvoiceSubmissionTracker",
  components: {VueGoodTable},
  mixins :[PaymentFormsMixin],
  data() {
    return {
      FORM_LABELS: FORM_LABELS,
      submittedInvoicesRows: [],
      submittedInvoicesColumns : VGT_COLUMNS.USER_INVOICE_SUBMISSION_COLUMNS,
      paginationOptions: VGT_PAGINATION_OPTIONS.USER_INVOICE_SUBMISSION_COLUMNS_PAGINATION_OPTIONS,
      noRecordsMessage: "No recent records exist.",

    }
  },
  created() {
    this.initializeInvoiceStatus()
  },
  computed: {
    ...mapGetters(["invoiceSubmissionStatusRecords"]),
    invoiceSubmissionStatusPaginationEnabled() {
      return this.invoiceSubmissionStatusRecords && this.invoiceSubmissionStatusRecords.length > 5
    },
  },
  methods: {
    initializeInvoiceStatus() {
      let invoiceTrackerRecords = JSON.parse(JSON.stringify(this.invoiceSubmissionStatusRecords))
      invoiceTrackerRecords.forEach((invoice) => {
        invoice.supplierName = this.isValidString(invoice.supplierName) ? invoice.supplierName : 'N/A'
        invoice.supplierNumber = this.isValidString(invoice.supplierNumber) ? invoice.supplierNumber : 'N/A'
        invoice.attachedFileName = invoice.attachedFileName && invoice.attachedFileName.length > 0 ? invoice.attachedFileName : ['N/A']
        invoice.formattedCreatedOn = this.isValidString(invoice.creationDateTime) ? this.convertDateTime(invoice.creationDateTime) : 'N/A'
        this.submittedInvoicesRows.push({...invoice, formType: CONSTANTS.INVOICE_FORM_TYPE.find(form => form.formCode === invoice.formType).formDisplayText})
      })
    },
    convertDateTime(dateTime){
      //For converting date-time to PST
      return  moment.utc(dateTime).tz("America/Los_Angeles").format('YYYY-MM-DD h:mm a')
    }
  }
}
</script>

<style scoped src="@/assets/stylesheets/vgtStyles.css">
</style>